module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to remove comment from this design?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('app-loader', {
    ref: "loader",
    staticClass: "loader-overlay--inside loader-overlay--radius"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c98f022","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/gallery/GalleryRemoveCommentModal.vue
// module id = 440
// module chunks = 2